import * as aspObjects from '../asp/aspObjects';

export var NO_VALUE = 'N/A';

export function systemName(systemID): string {
  let name = aspObjects.sensorsPool.getSensorBySensorID(systemID);
  return name.sic.toString() == '' ? systemID : name.sic.toString();
}

export function boolToStr(bool): string {
  return bool ? 'YES' : 'NO';
}
